module.exports = __webpack_public_path__ + "static/media/check-b.764e9aad.svg";